import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { getOrderItemDetails } from '../../../network/purchaseOrder';
import { useMutation, useQuery } from '@tanstack/react-query';
import { MdEdit } from 'react-icons/md';
import { BiSolidShow } from 'react-icons/bi';
import { ModalAppItemDetails } from '../ModalApp/ModalApp';
import { render } from '@testing-library/react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApiIsStock } from '../../../network/appointment';
const ItemOrderList = ({
  type,
  warehouse,
  setDataSource,
  dataSource,
  selectedIndex,
  setSelectedIndex,
  keyData,
  t,
  form,
  priceList = '',
  view,
}) => {
  const [selectData, setSelectData] = useState({});
  const [open, setOpen] = useState(false);
  const [searchTextItems, setSearchTextItems] = useState('');
  // console.log(dataSource,"dataSource");
  const [count, setCount] = useState(0);
  const { mutate: onGetItemDetails, data: itemDetails } = useMutation({
    mutationFn: (itemName) => getOrderItemDetails(keyData, itemName, priceList),
    onSuccess: (itemDetails) => {
      console.log(itemDetails, 'itemDetails');
      const newDataSource = [...dataSource];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        ...itemDetails?.message,
        rate: itemDetails?.message?.price_list_rate,
        amount: itemDetails?.message?.price_list_rate,
        warehouse: form.getFieldValue('set_warehouse'),
        // item_code: itemDetails?.message?.item_name,
      };
      setDataSource(newDataSource);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  useEffect(() => {
    const totalQty = dataSource.reduce(
      (total, item) => total + (Number(item.qty) || 0),
      0
    );
    const totalAmount = dataSource.reduce(
      (total, item) => total + (Number(item.amount) || 0),
      0
    );
    const netTotal = totalAmount;
    form.setFieldsValue({
      total_qty: totalQty,
      total: totalAmount,
      net_total: netTotal,
    });
  }, [dataSource]);
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTextItems, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  console.log(type, 'typetype swww');
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          placeholder={t.items}
          // value={record?.item_code}
          style={{ width: '200px' }}
          showSearch
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          disabled={view}
          filterOption={false}
          onSearch={(value) => {
            setSearchTextItems(value);
          }}
          popupMatchSelectWidth={false}
          onChange={(value) => {
            setSelectedIndex(index);
            // onGetItemDetails(value);
            onGetItemDetails(value.key);
          }}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },

    {
      title: t.AcceptedQuantity,
      dataIndex: 'qty',
      // dataIndex: 'received_qty',
      hidden: type === 'Purchase Reciept' ? false : true,
      render: (text, record, index) => (
        <Input
          placeholder={t.AcceptedQuantity}
          type="number"
          // value={record.amount}
          value={record.qty}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount: e.target.value * record.rate,
            };
            setDataSource(newDataSource);
          }}
          disabled={view}
          min={0}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.RejectedQuantity,
      dataIndex: 'rejected_qty',
      hidden: type === 'Purchase Reciept' ? false : true,
      render: (text, record, index) => (
        <Input
          placeholder={t.RejectedQuantity}
          type="number"
          value={record?.rejected_qty}
          disabled={view}
          min={0}
          // disabled
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.scheduleDate,
      dataIndex: 'schedule_date',
      hidden: type === 'Purchase Order' ? false : true,
      render: (text, record, index) => (
        <DatePicker
          allowClear
          value={record.schedule_date ? dayjs(record.schedule_date) : null}
          onChange={(date, dateString) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              schedule_date: dateString,
            };
            setDataSource(newDataSource);
          }}
          format="YYYY-MM-DD"
          disabled={view}
          placeholder={t.scheduleDate}
          style={{ width: '100%', marginBottom: '0px' }}
        />
      ),
    },
    {
      title: t.warehouse,
      dataIndex: 'warehouse',
      hidden: type === 'Purchase Order' ? false : true,
      render: (text, record, index) => (
        <Select
          placeholder={t.setWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.warehouse}
          disabled={view}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              warehouse: value,
            };
            setDataSource(newDataSource);
          }}
          options={warehouse?.data?.map((item) => ({
            value: item?.name,
            label: item?.warehouse_name,
          }))}
        />
      ),
    },
    {
      title: t.quantity + ' (SAR)',
      dataIndex: 'qty',
      hidden: type === 'Purchase Reciept' ? true : false,
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount: e.target.value * record.rate,
            };
            setDataSource(newDataSource);
          }}
          placeholder={t.quantity}
          type="number"
          value={record.qty}
          disabled={view}
          // min={0}
          width={100}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.Rate + ' (SAR)',
      dataIndex: 'rate',
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              rate: e.target.value,
              amount: e.target.value * +record?.qty,
            };
            console.log(newDataSource, 'newDataSource');
            setDataSource(newDataSource);
          }}
          placeholder={t.Rate}
          type="number"
          value={record.rate}
          disabled={view}
          min={0}
          width={100}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          value={record.amount}
          min={0}
          width={100}
          disabled
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => {
              setSelectedIndex(index);
              handleDetails(record.key);
            }}
          />
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      warehouse: form.getFieldValue('set_warehouse'),
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  const handleDetails = (key) => {
    const row = dataSource.find((item) => item.key === key);
    if (row) {
      setSelectData({
        ...row,
        schedule_date: dayjs(row.schedule_date).format('YYYY-MM-DD'),
      });
      setDataSource(
        dataSource.map((item) => ({
          ...item,
          schedule_date: dayjs(item.schedule_date).format('YYYY-MM-DD'),
        }))
      );
      setOpen(true);
      console.log('Row details:', row);
    }
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <ModalAppItemDetails
        setDataSource={setDataSource}
        dataSource={dataSource}
        selectedIndex={selectedIndex}
        open={open}
        setOpen={setOpen}
        type={type}
        t={t}
        selectData={selectData}
      />
    </Card>
  );
};

export default ItemOrderList;
